import { downloadRhInvoicePdf } from '../api/index'

const fetchInvoicePdfBlob = async (campaignId, invoiceId) => {
  const response = await downloadRhInvoicePdf(campaignId, invoiceId)
  return new Blob([response.data], { type: 'application/pdf' })
}

export const downloadInvoicePdf = async (campaignId, invoiceId, invoiceNumber) => {
  const blob = await fetchInvoicePdfBlob(campaignId, invoiceId)
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `facture-${invoiceNumber.replace(/\//g, '-')}.pdf`
  link.click()
  window.URL.revokeObjectURL(url)
}

export const printInvoicePdf = async (campaignId, invoiceId) => {
  const blob = await fetchInvoicePdfBlob(campaignId, invoiceId)
  const url = window.URL.createObjectURL(blob)
  const iframe = document.createElement('iframe')
  iframe.style.cssText = 'position:fixed;width:0;height:0;border:none;visibility:hidden'
  iframe.src = url
  document.body.appendChild(iframe)
  iframe.onload = () => {
    iframe.contentWindow?.focus()
    iframe.contentWindow?.print()
    setTimeout(() => {
      document.body.removeChild(iframe)
      window.URL.revokeObjectURL(url)
    }, 1000)
  }
}
